/**
 * @author: subhasish.ghosh@zoom.us
 */

import React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        scrollbarColor: "#959595 transparent",
        "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
          opacity: 0,
          transition: "opacity 0.3s ease",
        },
        "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
          borderRadius: 8,
          backgroundColor: "#959595",
          minHeight: 24,
        },
        "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
          {
            backgroundColor: "#1976d2",
          },
        "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
          {
            backgroundColor: "#1976d2",
          },
        "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
          {
            backgroundColor: "#1976d2",
          },

        "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },

        "&:focus::-webkit-scrollbar, &:focus *::-webkit-scrollbar": {
          opacity: 1,
        },
      },
    },
  },
});

const OperationsThemeProvider = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      {/* <ThemeProvider theme={theme}> */}
      <CssBaseline />
      {children}
      {/* </ThemeProvider> */}
    </StyledEngineProvider>
  );
};

export default OperationsThemeProvider;
